"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AtomLink = _interopRequireDefault(require("./AtomLink"));
var _InvoiceLineItem = _interopRequireDefault(require("./InvoiceLineItem"));
var _InvoicePayment = _interopRequireDefault(require("./InvoicePayment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Invoice model module.
 * @module model/Invoice
 * @version 3.0
 */
var Invoice = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Invoice</code>.
   * @alias module:model/Invoice
   */
  function Invoice() {
    _classCallCheck(this, Invoice);
    Invoice.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Invoice, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>Invoice</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Invoice} obj Optional instance to populate.
     * @return {module:model/Invoice} The populated <code>Invoice</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Invoice();
        if (data.hasOwnProperty('invoiceId')) {
          obj['invoiceId'] = _ApiClient["default"].convertToType(data['invoiceId'], 'Number');
        }
        if (data.hasOwnProperty('invoiceLegacyId')) {
          obj['invoiceLegacyId'] = _ApiClient["default"].convertToType(data['invoiceLegacyId'], 'String');
        }
        if (data.hasOwnProperty('invoiceReference')) {
          obj['invoiceReference'] = _ApiClient["default"].convertToType(data['invoiceReference'], 'String');
        }
        if (data.hasOwnProperty('accountId')) {
          obj['accountId'] = _ApiClient["default"].convertToType(data['accountId'], 'Number');
        }
        if (data.hasOwnProperty('serviceId')) {
          obj['serviceId'] = _ApiClient["default"].convertToType(data['serviceId'], 'Number');
        }
        if (data.hasOwnProperty('totalNewCharges')) {
          obj['totalNewCharges'] = _ApiClient["default"].convertToType(data['totalNewCharges'], 'Number');
        }
        if (data.hasOwnProperty('totalPreviousInvoice')) {
          obj['totalPreviousInvoice'] = _ApiClient["default"].convertToType(data['totalPreviousInvoice'], 'Number');
        }
        if (data.hasOwnProperty('subTotal')) {
          obj['subTotal'] = _ApiClient["default"].convertToType(data['subTotal'], 'Number');
        }
        if (data.hasOwnProperty('total')) {
          obj['total'] = _ApiClient["default"].convertToType(data['total'], 'Number');
        }
        if (data.hasOwnProperty('vat')) {
          obj['vat'] = _ApiClient["default"].convertToType(data['vat'], 'Number');
        }
        if (data.hasOwnProperty('totalAmountDue')) {
          obj['totalAmountDue'] = _ApiClient["default"].convertToType(data['totalAmountDue'], 'Number');
        }
        if (data.hasOwnProperty('outstandingAmountDue')) {
          obj['outstandingAmountDue'] = _ApiClient["default"].convertToType(data['outstandingAmountDue'], 'Number');
        }
        if (data.hasOwnProperty('lastPaymentAmount')) {
          obj['lastPaymentAmount'] = _ApiClient["default"].convertToType(data['lastPaymentAmount'], 'Number');
        }
        if (data.hasOwnProperty('currency')) {
          obj['currency'] = _ApiClient["default"].convertToType(data['currency'], 'String');
        }
        if (data.hasOwnProperty('units')) {
          obj['units'] = _ApiClient["default"].convertToType(data['units'], 'String');
        }
        if (data.hasOwnProperty('invoiceDate')) {
          obj['invoiceDate'] = _ApiClient["default"].convertToType(data['invoiceDate'], 'Date');
        }
        if (data.hasOwnProperty('paymentDueDate')) {
          obj['paymentDueDate'] = _ApiClient["default"].convertToType(data['paymentDueDate'], 'Date');
        }
        if (data.hasOwnProperty('category')) {
          obj['category'] = _ApiClient["default"].convertToType(data['category'], 'String');
        }
        if (data.hasOwnProperty('pastDueBalance')) {
          obj['pastDueBalance'] = _ApiClient["default"].convertToType(data['pastDueBalance'], 'Number');
        }
        if (data.hasOwnProperty('lastPaymentDate')) {
          obj['lastPaymentDate'] = _ApiClient["default"].convertToType(data['lastPaymentDate'], 'Date');
        }
        if (data.hasOwnProperty('message')) {
          obj['message'] = _ApiClient["default"].convertToType(data['message'], 'String');
        }
        if (data.hasOwnProperty('invoiceLineItems')) {
          obj['invoiceLineItems'] = _ApiClient["default"].convertToType(data['invoiceLineItems'], [_InvoiceLineItem["default"]]);
        }
        if (data.hasOwnProperty('invoicePayments')) {
          obj['invoicePayments'] = _ApiClient["default"].convertToType(data['invoicePayments'], [_InvoicePayment["default"]]);
        }
        if (data.hasOwnProperty('_links')) {
          obj['_links'] = _ApiClient["default"].convertToType(data['_links'], [_AtomLink["default"]]);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Invoice</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Invoice</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['invoiceLegacyId'] && !(typeof data['invoiceLegacyId'] === 'string' || data['invoiceLegacyId'] instanceof String)) {
        throw new Error("Expected the field `invoiceLegacyId` to be a primitive type in the JSON string but got " + data['invoiceLegacyId']);
      }
      // ensure the json data is a string
      if (data['invoiceReference'] && !(typeof data['invoiceReference'] === 'string' || data['invoiceReference'] instanceof String)) {
        throw new Error("Expected the field `invoiceReference` to be a primitive type in the JSON string but got " + data['invoiceReference']);
      }
      // ensure the json data is a string
      if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
        throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
      }
      // ensure the json data is a string
      if (data['units'] && !(typeof data['units'] === 'string' || data['units'] instanceof String)) {
        throw new Error("Expected the field `units` to be a primitive type in the JSON string but got " + data['units']);
      }
      // ensure the json data is a string
      if (data['category'] && !(typeof data['category'] === 'string' || data['category'] instanceof String)) {
        throw new Error("Expected the field `category` to be a primitive type in the JSON string but got " + data['category']);
      }
      // ensure the json data is a string
      if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
        throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
      }
      if (data['invoiceLineItems']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['invoiceLineItems'])) {
          throw new Error("Expected the field `invoiceLineItems` to be an array in the JSON data but got " + data['invoiceLineItems']);
        }
        // validate the optional field `invoiceLineItems` (array)
        var _iterator = _createForOfIteratorHelper(data['invoiceLineItems']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _InvoiceLineItem["default"].validateJSON(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ;
      }
      if (data['invoicePayments']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['invoicePayments'])) {
          throw new Error("Expected the field `invoicePayments` to be an array in the JSON data but got " + data['invoicePayments']);
        }
        // validate the optional field `invoicePayments` (array)
        var _iterator2 = _createForOfIteratorHelper(data['invoicePayments']),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _item = _step2.value;
            _InvoicePayment["default"].validateJSON(_item);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        ;
      }
      if (data['_links']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['_links'])) {
          throw new Error("Expected the field `_links` to be an array in the JSON data but got " + data['_links']);
        }
        // validate the optional field `_links` (array)
        var _iterator3 = _createForOfIteratorHelper(data['_links']),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _item2 = _step3.value;
            _AtomLink["default"].validateJSON(_item2);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        ;
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} invoiceId
 */
Invoice.prototype['invoiceId'] = undefined;

/**
 * @member {String} invoiceLegacyId
 */
Invoice.prototype['invoiceLegacyId'] = undefined;

/**
 * @member {String} invoiceReference
 */
Invoice.prototype['invoiceReference'] = undefined;

/**
 * @member {Number} accountId
 */
Invoice.prototype['accountId'] = undefined;

/**
 * @member {Number} serviceId
 */
Invoice.prototype['serviceId'] = undefined;

/**
 * @member {Number} totalNewCharges
 */
Invoice.prototype['totalNewCharges'] = undefined;

/**
 * @member {Number} totalPreviousInvoice
 */
Invoice.prototype['totalPreviousInvoice'] = undefined;

/**
 * @member {Number} subTotal
 */
Invoice.prototype['subTotal'] = undefined;

/**
 * @member {Number} total
 */
Invoice.prototype['total'] = undefined;

/**
 * @member {Number} vat
 */
Invoice.prototype['vat'] = undefined;

/**
 * @member {Number} totalAmountDue
 */
Invoice.prototype['totalAmountDue'] = undefined;

/**
 * @member {Number} outstandingAmountDue
 */
Invoice.prototype['outstandingAmountDue'] = undefined;

/**
 * @member {Number} lastPaymentAmount
 */
Invoice.prototype['lastPaymentAmount'] = undefined;

/**
 * @member {String} currency
 */
Invoice.prototype['currency'] = undefined;

/**
 * @member {String} units
 */
Invoice.prototype['units'] = undefined;

/**
 * @member {Date} invoiceDate
 */
Invoice.prototype['invoiceDate'] = undefined;

/**
 * @member {Date} paymentDueDate
 */
Invoice.prototype['paymentDueDate'] = undefined;

/**
 * @member {String} category
 */
Invoice.prototype['category'] = undefined;

/**
 * @member {Number} pastDueBalance
 */
Invoice.prototype['pastDueBalance'] = undefined;

/**
 * @member {Date} lastPaymentDate
 */
Invoice.prototype['lastPaymentDate'] = undefined;

/**
 * @member {String} message
 */
Invoice.prototype['message'] = undefined;

/**
 * @member {Array.<module:model/InvoiceLineItem>} invoiceLineItems
 */
Invoice.prototype['invoiceLineItems'] = undefined;

/**
 * @member {Array.<module:model/InvoicePayment>} invoicePayments
 */
Invoice.prototype['invoicePayments'] = undefined;

/**
 * @member {Array.<module:model/AtomLink>} _links
 */
Invoice.prototype['_links'] = undefined;
var _default = exports["default"] = Invoice;